import {useQuery} from "@tanstack/react-query";
import {PaymentInformationApiClient, PaymentInformationDto} from "../../../../client/payment/PaymentInformationApiClient";

export function usePaymentInformationQuery(
    submissionId: number | undefined,
    paymentRequired: boolean | undefined,
    paymentInformationApiClient: PaymentInformationApiClient,
    authorizationSucceeded: boolean = true
) {
    return useQuery<PaymentInformationDto | undefined>({
        queryKey: ['paymentInformation', submissionId],
        queryFn: () => new Promise<PaymentInformationDto>((resolve, reject) => {
            paymentInformationApiClient.findBySubmissionId(submissionId!)
                .then((result) => {
                    if (result) {
                        return resolve(result);
                    }

                    return reject(new Error("Payment information not yet available"));
                })
        }),
        enabled: paymentRequired === true && !!submissionId && authorizationSucceeded,
        retry: 5,
        retryDelay: (failureCount) => (2 ** failureCount) * 2000
    });
}
